<template>
  <div class="overflow-x-auto py-2 sm:px-6 lg:px-2 rounded-md">
    <table class="w-full">
      <slot />
      <tbody>
        <tr v-for="(row, index) in paginatedItems" :key="index" class="hover:shadow-lg hover:-translate-y-1 hover:-translate-x-1 transition-all z-9" :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'">
          <td class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 cursor-pointer min-w-[10px]">
            <div :class="{ 'text-center': center }">
              <span class="pl-2">
                {{ row?.name?.length > 20
                  ? row?.name.slice(0, 20).concat("...")
                  : row?.name
                }}
              </span>
            </div>
          </td>
          <td class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 cursor-pointer min-w-[10px]">
            <div :class="{ 'text-center': center }">
              <span class="pl-2">
                {{ row.cellphone }}
              </span>
              <i v-if="!row.cellphone" class="text-gray-400">
                não informado
              </i>
            </div>
          </td>
          <td class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 cursor-pointer min-w-[10px]">
            <div :class="{ 'text-center': center }">
              <a class="pl-2 text-black" :href="`http://instagram.com/${row.instagram}`" target="_blank">
                {{ row?.instagram?.length > 20
                  ? row?.instagram?.slice(0, 20).concat("...")
                  : row?.instagram
                }}
              </a>
              <i v-if="!row.instagram" class="text-gray-400">
                não informado
              </i>
            </div>
          </td>
          <td class="text-left whitespace-nowrap pr-3 text-sm text-gray-900 sm:pl-0 cursor-pointer min-w-[10px]">
            <div :class="{ 'text-center': center }">
              <span class="pl-2">
                {{ row?.facebook?.length > 20
                  ? row?.facebook?.slice(0, 20).concat("...")
                  : row?.facebook
                }}
              </span>
              <i v-if="!row.facebook" class="text-gray-400">
                não informado
              </i>
            </div>
          </td>

          <td class="flex justify-center whitespace-nowrap py-1 pr-2 text-sm font-medium text-gray-900 sm:pl-0">
            <ActionsButtonVue
              :link="url.edit + paginatedItems[index].id"
              @delete="deleteEmployee(paginatedItems[index].id)"
            />
            <!-- @getReport="generateReport(items[index].id)" -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="items.length > 10">
    <section class="mt-4 flex justify-center">
      <Buttons
        class="mr-4"
        @click="prevPage"
        :disabled="currentPage === 1"
        :label="'Anterior'"
        :icon="'fa-solid fa-arrow-left'"
      />

      <Buttons
        class="ml-4"
        @click="nextPage"
        :disabled="currentPage === totalPages"
        :label="'Próximo'"
        :icon="'fa-solid fa-arrow-right'"
      />
    </section>

    <p>Página {{ currentPage }} de {{ totalPages }}</p>
  </div>
</template>

<script>
import ActionsButtonVue from '@/components/Tables/ActionsButton.vue'
import clientsService from '../services/clients.service'
import Buttons from '@/components/Buttons/Create.vue'
import * as toast from '@/helpers/useToast'
import { storeApp } from '@/store'

export default {
  props: {
    center: { Boolean, default: false },
    items: { type: Array, required: true },
    itemsPerPage: { type: Number, default: 10 }
  },
  components: {
    Buttons,
    ActionsButtonVue
  },
  data () {
    return {
      currentPage: 1,
      url: {
        edit: '/client/edit/',
        delete: '/client/delete/'
      },
      columns: this.dataTable,
      toast: toast,
      showModal: false,
      modalTitle: 'Selecione o relatório que deseja',
      currentEmployee: {}
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },
    paginatedItems () {
      const start = (this.currentPage - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.items.slice(start, end)
    }
  },
  methods: {
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    deleteEmployee (id) {
      storeApp.state.loading = true
      const confirm = window.confirm('Deseja realmente remover esse cliente ?')
      if (confirm) {
        clientsService.deleteClient(id).then(res => {
          if (res.data.success) {
            this.toast.showToast(
              'Sucesso',
              'Cliente removido com sucesso!',
              'success'
            )
          }
          window.location.reload()
        }).catch(err => {
          this.toast.showToast(
            'Erro',
            'Algo deu errado ao remover cliente',
            'error'
          )
        })
      }
      storeApp.state.loading = false
    }
  }
}
</script>

<style scoped>
button {
  margin: 5px;
}
</style>
